import { gql } from "@apollo/client"

export const TRANSFER_STUDENT_LOCATION = gql(`mutation TransferStudentLocation($studentId:UUID!, $locationId:UUID!, $personIds:[UUID!]!){
  transferStudentLocation(input: {studentId:$studentId,locationId:$locationId,personIds:$personIds}) {
    student {
      ... SelectedStudent_Student
    }
}}
      fragment SelectedStudent_Student on Student {
    __typename
    id 
    locationId
    location{
        name
    }
    firstName
    middleName
    lastName
    dob
    postalCode
    parentEmail
    parentPhone
    email
    startDate
    endDate
    expired
    references
    parentalConsentStatus
    lastConsentAction{
        id
        type
        createdAt
    }
    consentEmailSentTimes
    persons {
    edges{
    cursor
    node{
    id}}
    
        }
    studentCustomFields {
        __typename
        value
        customField {
            __typename
            id
        }
    }
  } `)